import styled from '@emotion/styled';
import { BREAKPOINTS_LEGACY } from '@sortlist-frontend/design-system/legacy';

export const Header = styled.div`
  @media only screen and (min-width: ${BREAKPOINTS_LEGACY.xs}) {
    h1 {
      font-size: 4rem;
    }
  }
`;

export const CardWrapper = styled.div`
  @media only screen and (min-width: ${BREAKPOINTS_LEGACY.xs}) {
    max-width: 18rem;
  }
`;
